import { Component, OnInit } from '@angular/core';
import {EquipmentType,SQACode,SQASubCode} from 'src/app/models'
import {EquipmentService,SqacodeService,SqasubcodeService,MessageService} from 'src/app/services/'
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'bart-sqa-code-manager',
  templateUrl: './sqa-code-manager.component.html',
  styleUrls: ['./sqa-code-manager.component.scss']
})
export class SqaCodeManagerComponent implements OnInit {
  public allSQACode:AdminSQACode[];
  public allSQASubCode:AdminSQASubCode[];
  public allEquipmentType:AdminEquipmentType[];

  public sqaCodeList:SelectItem[]=null
  public selectedSQACodeId:number=null;

  public sqaSubCodeList:SelectItem[]=null
  public selectedSQASubCodeId:number=null;
  public selectedSQACodeDescription:string="";

  public sqaCodeFormfields?:AdminSQACode=null
  public sqaSubCodeFormfields?:AdminSQASubCode=null
  public selectedSQASubCodeDescription:string="";

  public displaySQACodeDialog:boolean=false;
  public displaySQASubCodeDialog:boolean=false;

  
   getSQACodesParam={
    "GETSQACODES":{
      SQACode:null,
      SQACodeId:null,
      AllCodes:1
    }
   }

   getSqaSubCodesParam={
    "GETSQASUBCODES":{
      SQACodeID:null,
      SQASubCodeID:null,
      SQASubCode:null,
      allCodes:1,
      isFrequencyFlag:null,
      isSQACode:null,
      isSQASubCode:null
    }
  
   }
  constructor
  (
    private _equipmentService:EquipmentService,
    private _sqaCodeService:SqacodeService,
    private _sqaSubcodeService:SqasubcodeService,
    private _messageService:MessageService
  ) 
  { 
    this.sqaCodeFormfields=new AdminSQACode();
    this.sqaSubCodeFormfields=new AdminSQASubCode();
  }

  ngOnInit() 
  {
    this.loadEquipmentTypes();
    this.loadSQACodes();
    this.loadSQASubCodes();
  }

  public loadEquipmentTypes()
  {
    this.allEquipmentType=[];
    this._equipmentService.getEquipmentTypes().subscribe(data=>
      {
        if(data!=null && data.equipmentType && data.equipmentType.length>0)
        {
           this.allEquipmentType=data.equipmentType
        }
      },
      (error)=>
      {
         console.log(error);
      });
  }
  public loadSQACodes()
  {
    this.allSQACode=[];
    this.sqaCodeList=[]
    this.getSQACodesParam.GETSQACODES={SQACode:null,SQACodeId:null,AllCodes:1};
    this._sqaCodeService.getSQACodes(JSON.stringify(this.getSQACodesParam)).subscribe(data=>
      {
        if(data!=null && data.length>0)
        {
           this.allSQACode=data
           this.sqaCodeList=this.allSQACode.map(data => ({
            label: data.SQADescription,
            value: data.SQACodeId,
          }));
        }
      },
      (error)=>
      {
         console.log(error);
      });
  }
  public loadSQASubCodes()
  {
    this.allSQASubCode=[];
    this.sqaSubCodeList=[];
    this.getSqaSubCodesParam.GETSQASUBCODES=
    {
      SQACodeID:null,
      SQASubCodeID:null,
      SQASubCode:null,
      allCodes:1,
      isFrequencyFlag:null,
      isSQACode:null,
      isSQASubCode:null
    }
    this._sqaSubcodeService.getSqaSubCodes(JSON.stringify(this.getSqaSubCodesParam)).subscribe(data=>
      {
        if(data!=null && data.length>0)
        {
           this.allSQASubCode=data
           this.sqaSubCodeList=this.allSQASubCode.map(data => ({
            label: data.sqaSubDescription,
            value: data.sqaSubCodeId,
          }));
        }
      },
      (error)=>
      {
         console.log(error);
      });
  }
  public ddlSQASubCodeChanged()
  {
    
    this.allSQACode.forEach(item => item.isChecked = false);
    if(this.selectedSQASubCodeId)
    {
      let sqaSubCodeId:number=this.selectedSQASubCodeId;
      this.getSQASubCodesFromSubCodeId(sqaSubCodeId);
      this.selectedSQASubCodeDescription=this.sqaSubCodeList.find(x=>x.value==sqaSubCodeId).label
    }
  }
  public ddlSQACodeChanged()
  {
    this.allEquipmentType.forEach(item => item.isChecked = false);
    this.allSQASubCode.forEach(item => item.isChecked = false);
    if(this.selectedSQACodeId)
    {
      let sqaCodeId:number=this.selectedSQACodeId;
      this.getEquipmentTypes(sqaCodeId);
      this.getSQASubCodes(sqaCodeId);
      this.selectedSQACodeDescription=this.sqaCodeList.find(x=>x.value==sqaCodeId).label
    }
  }
  public getEquipmentTypes(sqaCodeId:number)
  {
   
    let getEquipmentTypesParam={
      "GETSQACODEEQUIPMENTTYPES":{
        SqacodeId:sqaCodeId
      }
    }
    this._sqaCodeService.getSQACodeEquipmentTypes(JSON.stringify(getEquipmentTypesParam)).subscribe(data=>
      {
        if(data!=null && data.length>0)
        {
          this.allEquipmentType.forEach
          (
            item => item.isChecked = 
            (
              data.find(x=>x.equipmentTypeId==item.EquipmentTypeId)!=null?true:false
            )
          );
        }
      },
      (error)=>
      {
         console.log(error);
      });
  }
  public getSQASubCodes(sqaCodeId:number)
  {
    this.getSqaSubCodesParam.GETSQASUBCODES=
    {
      SQACodeID:sqaCodeId,
      SQASubCodeID:null,
      SQASubCode:null,
      allCodes:1,
      isFrequencyFlag:null,
      isSQACode:1,
      isSQASubCode:0
    }
    this._sqaSubcodeService.getSqaSubCodes(JSON.stringify(this.getSqaSubCodesParam)).subscribe(data=>
      {
        if(data!=null && data.length>0)
        {
          this.allSQASubCode.forEach
          (
            item => item.isChecked = 
            (
              data.find(x=>x.sqaSubCodeId==item.sqaSubCodeId)!=null?true:false
            )
          );
        }
      },
      (error)=>
      {
         console.log(error);
      });
  }
  public getSQASubCodesFromSubCodeId(sqaSubCodeId:number) 
  {
    
    this.getSqaSubCodesParam.GETSQASUBCODES=
    {
      SQACodeID:null,
      SQASubCodeID:sqaSubCodeId,
      SQASubCode:null,
      allCodes:1,
      isFrequencyFlag:null,
      isSQACode:0,
      isSQASubCode:1
    }

    this._sqaSubcodeService.getSqaSubCodes(JSON.stringify(this.getSqaSubCodesParam)).subscribe(data=>
      {
        if(data!=null && data.length>0)
        {
          this.allSQACode.forEach
          (
            item => item.isChecked = 
            (
              data.find(x=>x.sqaCodeId==item.SQACodeId)!=null?true:false
            )
          );
        }
      },
      (error)=>
      {
         console.log(error);
      });
  }
  public openSQACodeDialog(eventType:string)
  {
    this.sqaCodeFormfields=null;
    if(eventType.toLowerCase()=="add")
    {
      this.sqaCodeFormfields=new AdminSQACode();
    }
    else
    {
      if(this.selectedSQACodeId!=null)
      {

        this.sqaCodeFormfields=Object.assign({}, this.allSQACode.find(x=>x.SQACodeId==this.selectedSQACodeId));
        //this.sqaCodeFormfields=this.selectedSQACodeDetails
      }
    }
    this.displaySQACodeDialog=true;
  }
  public openSQASubCodeDialog(eventType:string)
  {
    if(eventType.toLowerCase()=="add")
    {
      this.sqaSubCodeFormfields=new AdminSQASubCode();
    }
    else
    {
      if(this.selectedSQASubCodeId!=null)
      {
        //Object.assign({}, obj);
        //this.sqaSubCodeFormfields=this.selectedSQASubCodeDetails
        this.sqaSubCodeFormfields=Object.assign({}, this.allSQASubCode.find(x=>x.sqaSubCodeId==this.selectedSQASubCodeId));
      }
    }
    this.displaySQASubCodeDialog=true;
  }
  public SaveSQACode()
  {
    let msg = '';
    let validSQA:boolean = true;
    let isOnWebForm:boolean=false;
    let isActive:boolean=false;
    if(this.sqaCodeFormfields.SQACode==null || this.sqaCodeFormfields.SQACode=="")
    {
      msg += "Code is required.\n";
      validSQA=false;
    }
    else if (isNaN(Number(this.sqaCodeFormfields.SQACode))) {
			msg += "Code must be a number.<br/>";
			validSQA=false;
		}
    if (this.sqaCodeFormfields.SQADescription==null || this.sqaCodeFormfields.SQADescription=="") 
    {
      msg += "Description is required.\n";
      validSQA=false;
    }
    let sqaCodeParam=null
    if(validSQA)
    {
      isActive=Boolean( this.sqaCodeFormfields.isActiveFlag)
      isOnWebForm=Boolean( this.sqaCodeFormfields.isWebFormActiveFlag)
      let oldSQACode:string="";
     if(this.allSQACode.find(x=>x.SQACodeId==this.sqaCodeFormfields.SQACodeId))
     {
        oldSQACode=this.allSQACode.find(x=>x.SQACodeId==this.sqaCodeFormfields.SQACodeId).SQACode
     }

      this.ChcekCode(this.sqaCodeFormfields.SQACode,false,(count) =>
      {
          //[Code already exist] message show only for Save New Recod only
         if(count>0 && (this.sqaCodeFormfields.SQACode!=oldSQACode))
         {
          this._messageService.showAlertMessage("Code already exists.");
         }
         else
         {
            if(this.sqaCodeFormfields.SQACodeId!=null && this.sqaCodeFormfields.SQACodeId>0)
            {
              sqaCodeParam=
              {
                "UPDATESQACODE":
                  {
                    SQACode:this.sqaCodeFormfields.SQACode,
                    SQADescription:this.sqaCodeFormfields.SQADescription,
                    isWebFormActiveFlag:isOnWebForm==true?1:0,
                    isActiveFlag:isActive==true?1:0,
                    SQACodeID:this.sqaCodeFormfields.SQACodeId
                 }
              }
              this._sqaCodeService.updateSQACode(JSON.stringify(sqaCodeParam)).subscribe(data=>
                {
                  msg = "SQA Code saved successfully";
                  this._messageService.showAlertMessage("SQA Code saved successfully");
                  this.loadSQACodes();
                  this.selectedSQACodeId=this.sqaCodeFormfields.SQACodeId;
                   this.displaySQACodeDialog=false
                  
                },
                (error)=>
                {
                  validSQA=false
                  msg=error.message;
                  
                }
                );
            }
            else
            {
              sqaCodeParam=
              {
                "CREATESQACODE":
                  {
                    SQACode:this.sqaCodeFormfields.SQACode,
                    SQADescription:this.sqaCodeFormfields.SQADescription,
                    isWebFormActiveFlag:isOnWebForm==true?1:0,
                    isActiveFlag:isActive==true?1:0,
                    DisplaySortOrder:0
                }
              }
              this._sqaCodeService.createSQACode(JSON.stringify(sqaCodeParam)).subscribe(data=>
                {
                  this._messageService.showAlertMessage("SQA Code saved successfully");
                  this.loadSQACodes();
                  this.selectedSQACodeId=null;
                  this.displaySQACodeDialog=false
                },
                (error)=>
                {
                  validSQA=false
                  msg=error.message;
                }
                );
            }
         }
      });
    }
    if(!validSQA)
    {
      this._messageService.showAlertMessage(msg); 
    }
  }
  public SaveSQASubCode()
  {
    let msg = '';
    let validSQA:boolean = true;
    let isCustome:boolean=false;
    let isActive:boolean=false;
    if(this.sqaSubCodeFormfields.sqaSubCode==null || this.sqaSubCodeFormfields.sqaSubCode=="")
    {
      msg += "Code is required.\n";
      validSQA=false;
    }
    if (this.sqaSubCodeFormfields.sqaSubDescription==null || this.sqaSubCodeFormfields.sqaSubDescription=="") 
    {
      msg += "Description is required.\n";
      validSQA=false;
    }
    let sqaSubCodeParam=null
    if(validSQA)
    {
      isActive=Boolean(this.sqaSubCodeFormfields.isActiveFlag)
      isCustome=Boolean(this.sqaSubCodeFormfields.isCustomFlag)
      this.ChcekCode(this.sqaSubCodeFormfields.sqaSubCode,true,(count) =>
      {
         let oldSQASubCode:string="";
         if(this.allSQASubCode.find(x=>x.sqaSubCodeId==this.sqaSubCodeFormfields.sqaSubCodeId))
         {
          oldSQASubCode=this.allSQASubCode.find(x=>x.sqaSubCodeId==this.sqaSubCodeFormfields.sqaSubCodeId).sqaSubCode
         }
          //[Code already exist] message show only for Save New Recod only
         if(count>0 && (this.sqaSubCodeFormfields.sqaSubCode!=oldSQASubCode))
         {
          this._messageService.showAlertMessage("Code already exists.");
         }
         else
         {
            if(this.sqaSubCodeFormfields.sqaSubCodeId!=null && this.sqaSubCodeFormfields.sqaSubCodeId>0)
            {
              sqaSubCodeParam=
              {
                "UPDATESQASUBCODE":
                  {
                    sqasubcode:this.sqaSubCodeFormfields.sqaSubCode,
                    sqasubdescription:this.sqaSubCodeFormfields.sqaSubDescription,
                    isactiveflag:isActive==true?1:0,
                    iscustomflag:isCustome==true?1:0,
                    sqasubcodeid:this.sqaSubCodeFormfields.sqaSubCodeId
                 }
              }
              this._sqaSubcodeService.updateSQASubCode(JSON.stringify(sqaSubCodeParam)).subscribe(data=>
                {
                  //msg = "SQA Sub Code saved successfully";
                  this._messageService.showAlertMessage("SQA Sub Code saved successfully");
                  this.loadSQASubCodes();
                  this.selectedSQASubCodeId=this.sqaSubCodeFormfields.sqaSubCodeId;
                   this.displaySQASubCodeDialog=false
                },
                (error)=>
                {
                  validSQA=false
                  msg=error.message;
                }
                );
            }
            else
            {
              sqaSubCodeParam=
              {
                "CREATESQASUBCODE":
                  {
                    sqasubcode:this.sqaSubCodeFormfields.sqaSubCode,
                    sqasubdescription:this.sqaSubCodeFormfields.sqaSubDescription,
                    isactiveflag:isActive==true?1:0,
                    iscustomflag:isCustome==true?1:0,
                    DisplaySortOrder:0
                }
              }
              this._sqaSubcodeService.createSQASubCode(JSON.stringify(sqaSubCodeParam)).subscribe(data=>
                {
                  this._messageService.showAlertMessage("SQA Sub Code saved successfully");
                  this.loadSQASubCodes();
                  this.selectedSQASubCodeId=null
                   this.displaySQASubCodeDialog=false
                },
                (error)=>
                {
                  validSQA=false
                  msg=error.message;
                }
                );
            }
         }
      });
    }
    if(!validSQA)
    {
      this._messageService.showAlertMessage(msg); 
    }
  }
  public ChcekCode(code:string,isCheckSubCode:boolean=false,callBack)
  {
     let count:number=0;
     if(isCheckSubCode)
     {
      this.getSqaSubCodesParam.GETSQASUBCODES=
      {
        SQACodeID:null,
        SQASubCodeID:null,
        SQASubCode:code,
        allCodes:1,
        isFrequencyFlag:null,
        isSQACode:null,
        isSQASubCode:null
      }
      this._sqaSubcodeService.getSqaSubCodes(JSON.stringify(this.getSqaSubCodesParam)).subscribe(data=>
      {
            if(data!=null)
            {
              count=data.length;
            }
            callBack(count);     
      },
      (error)=>
        {
          callBack(count); 
        }
      )
     }
     else
     {
        this.getSQACodesParam.GETSQACODES={SQACode:code,SQACodeId:null,AllCodes:1};;
        
        this._sqaCodeService.getSQACodes(JSON.stringify(this.getSQACodesParam)).subscribe(data=>
        {
              if(data!=null)
              {
                count=data.length;
              }
              callBack(count);     
        },
        (error)=>
          {
            callBack(count); 
          }
        )
      }
   }
   public displayConfirmSQACodeDialog:boolean=false
   public displayConfirmSQASubCodeDialog:boolean=false
   public displayConfirmDialog()
   {
     this.displayConfirmSQACodeDialog=false;
     this.displayConfirmSQASubCodeDialog=false
     if(this.selectedSQACodeId)
     {
      this.displayConfirmSQASubCodeDialog=true
     }
     else if(this.selectedSQASubCodeId)
     {
      this.displayConfirmSQACodeDialog=true
     }
   }
   public clearSelection()
   {
    this.selectedSQASubCodeId=null
    this.selectedSQACodeId=null;
   }
   public isMessageAlreadyShowForSQACodeLing:boolean=false;
   public SaveSQACodeLink()
   {
     
     console.log(this.allEquipmentType.filter(x=>x.isChecked==true))
     console.log(this.allSQACode.filter(x=>x.isChecked==true))
     console.log(this.allSQASubCode.filter(x=>x.isChecked==true))

    let codeArray:number[] = [];
    let typeArray:number[] = [];
    this.isMessageAlreadyShowForSQACodeLing=false;
    //Start=>Api Parameters
    //#region Parameters
    let deleteEquipmentTypeLinkParam=
    {
      "DELETEEQUIPMENTTYPELINK":
        {
         SQACodeID:null
        }
     }
    let deleteSQACodeLinkParam=
    {
      "DELETESQACODELINK":
        {
          SQACodeID:null
        }
     }
     let updateSQACodeLinkParam=
     {
      "DELETESQACODELINK":
        {
          SQACodeID:null
        },
      "CREATESQACODELINK":
        {
          SQACodeID:null,
          SQASubCodeIDList:null
        }
     }
     let updateEquipmentTypeLinkParam=
     {
      "CREATEEQUIPMENTTYPELINK":
      {
        SQACodeID:null,
        equipmentTypeIdList:null
      }
     }
     //#endregion
     if(this.selectedSQACodeId!=null && this.selectedSQACodeId>0)
     {
       this.allEquipmentType.filter(x=>x.isChecked==true).forEach((node)=>
       {
         typeArray.push(node.EquipmentTypeId)
       })
       this.allSQASubCode.filter(x=>x.isChecked==true).forEach((node)=>
       {
         codeArray.push(node.sqaSubCodeId)
       });
      //******************************* Delete SQA Code Link***********************************************************//
        deleteSQACodeLinkParam.DELETESQACODELINK.SQACodeID=this.selectedSQACodeId
        this._sqaCodeService.deleteSQACodeLink(JSON.stringify(deleteSQACodeLinkParam)).subscribe(data=>
        {
          this.handleApiResponse(data);
          //******************************* Update SQA Code Link***********************************************************//
          if(codeArray.length>0)
          {
              updateSQACodeLinkParam.CREATESQACODELINK.SQACodeID=this.selectedSQACodeId
              updateSQACodeLinkParam.DELETESQACODELINK.SQACodeID=this.selectedSQACodeId
              updateSQACodeLinkParam.CREATESQACODELINK.SQASubCodeIDList=codeArray.join(",");
              this._sqaCodeService.updateSQACodeLink(JSON.stringify(updateSQACodeLinkParam)).subscribe(data=>
              {
                this.handleApiResponse(data);
                this.selectedSQACodeId=null
              },
              (error)=>
              {
                console.log(error);
              });
          }
       //******************************* DELETE EQUIPMENTTYPE LINK***********************************************************//
        },
        (error)=>
        {
          console.log(error);
        });
      
        deleteEquipmentTypeLinkParam.DELETEEQUIPMENTTYPELINK.SQACodeID=this.selectedSQACodeId;
        this._sqaCodeService.deleteEquipmentTypeLink(JSON.stringify(deleteEquipmentTypeLinkParam)).subscribe(data=>
        {
          this.handleApiResponse(data);
           //******************************* createEquipmentTypeLink***********************************************************//
            if(typeArray.length>0)
            {
                updateEquipmentTypeLinkParam.CREATEEQUIPMENTTYPELINK.SQACodeID=this.selectedSQACodeId
                updateEquipmentTypeLinkParam.CREATEEQUIPMENTTYPELINK.equipmentTypeIdList=typeArray.join(",")
                this._sqaCodeService.createEquipmentTypeLink(JSON.stringify(updateEquipmentTypeLinkParam)).subscribe(data=>
                {
                  this.handleApiResponse(data);
                  this.selectedSQACodeId=null
                },
                (error)=>
                {
                  console.log(error);
                });
            }
        },
        (error)=>
        {
          console.log(error);
        });
       
     }
     else if(this.selectedSQASubCodeId!=null && this.selectedSQASubCodeId>0)
     {
        this.allSQACode.filter(x=>x.isChecked==true).forEach((node)=>
        {
          codeArray.push(node.SQACodeId)
        })
         let DeleteSQASubCodeLinkParam=
         {
          "DELETESQASUBCODELINK":
            {
              sqaSubCodeId:this.selectedSQASubCodeId
            }
         }
         let CreateSQASubCodeLinkParam=
         {
          "CREATESQASUBCODELINK":
            {
              sqaSubCodeId:this.selectedSQASubCodeId,
              sqaCodeIdList:codeArray!=null&& codeArray.length>0?codeArray.join(","):null
          }
         }
         //*******************************deleteSQASubCodeLink***********************************************************//***********************************************************//
       this._sqaSubcodeService.deleteSQASubCodeLink(JSON.stringify(DeleteSQASubCodeLinkParam)).subscribe(data=>
        {
          this.handleApiResponse(data);
          if(codeArray.length>0)
          {
            //*******************************createSQASubCodeLink***********************************************************//***********************************************************//
            this._sqaSubcodeService.createSQASubCodeLink(JSON.stringify(CreateSQASubCodeLinkParam)).subscribe(data=>
              {
                this.handleApiResponse(data);
                this.selectedSQASubCodeId=null
              },
              (error)=>
              {
                console.log(error);
              })
          }
        },
        (error)=>
        {
           console.log(error);
        })
      
     }
   }
  public handleApiResponse(data:any)  
  {
     if(data!=null && !data.error)
     {
       if(!this.isMessageAlreadyShowForSQACodeLing)
       {
        this._messageService.showAlertMessage("SQA Codes saved.");
        this.isMessageAlreadyShowForSQACodeLing=true
        this.displayConfirmSQACodeDialog=false;
        this.displayConfirmSQASubCodeDialog=false;
       }
       
     }
     else if(data!=null && data.error)
     {
      this._messageService.showAlertMessage(data.error);
     }
  }
  public getSQACodeCheckedCount()
  {
    return this.allSQACode.filter(x=>x.isChecked==true).length;
  }
  public getEquipmentTypeCheckedCount()
  {
    return this.allEquipmentType.filter(x=>x.isChecked==true).length;
  }
  public getSQASubCodeCheckedCount()
  {
    return this.allSQASubCode.filter(x=>x.isChecked==true).length;
  }
}
export class AdminEquipmentType extends EquipmentType
{
  public isChecked:boolean=false;
}
export class AdminSQACode extends SQACode
{
  // public selectedSQACodeId:number=null;
  public isChecked:boolean=false;
}
export class AdminSQASubCode extends SQASubCode
{
  // public selectedSQASubCodeId:number=null;
  public isChecked:boolean=false;
}